"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (props) {
  if (props.test) {
    return props.children;
  }
  return false;
};


//////////////////
// WEBPACK FOOTER
// ./~/@rafacdb/bah/lib/operator/if.js
// module id = 113
// module chunks = 0